import React from 'react';
import { LogoMascot, Wordmark } from './BrandArtwork';
import { FooterCatVignette } from './FooterCatVignette';
import { navLinks } from '../data/site';
export function SiteFooter() {
  return <footer className="relative min-h-[620px] overflow-hidden border-t border-ink/10 bg-cream md:min-h-[640px] lg:min-h-[660px]" data-id="element-127" data-mp="3mh12s95xt21o">
      <FooterCatVignette data-id="element-128" data-mp="3hhojfye9yd3u" />

      <div className="relative z-10 mx-auto flex min-h-[620px] max-w-content flex-col px-5 pb-8 pt-16 md:min-h-[640px] md:px-8 lg:min-h-[660px] lg:px-10" data-id="element-129" data-mp="3hgddbrxcwt9k">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12" data-id="element-130" data-mp="38gqcb78jhph1">
          <div className="md:col-span-6" data-id="element-131" data-mp="33ioq4dftha1c">
            <div className="inline-flex items-center gap-[4px]" data-id="element-132" data-mp="33jgdj0z9g1gj">
              <LogoMascot className="h-8 w-auto shrink-0 md:h-10" knockoutId="footer-mascot-knockout" data-id="element-133" data-mp="2yk3s8ko1f2g2" />
              <Wordmark className="h-8 w-auto md:h-10" knockoutId="footer-wordmark-knockout" data-id="element-134" data-mp="11qishrbq6d65" />
            </div>
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-ink/75" data-id="element-135" data-mp="wq4gjy706j2u">
              A boutique app studio building original apps for learning, life and play.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 md:col-span-6 md:grid-cols-2" data-id="element-136" data-mp="1anvffe5wxs7w">
            <nav aria-label="Footer" data-id="element-137" data-mp="vu8sepjuyik1">
              <h2 className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink/55" data-id="element-138" data-mp="10rsay1nl9hhs">
                Sections
              </h2>
              <ul className="mt-4 space-y-1" data-id="element-139" data-mp="1oiedjdetq9ke">
                {navLinks.map(link => <li key={link.href} data-id="element-140" data-mp="1tfegvgkagy7t">
                    <a href={link.href} className="inline-flex min-h-[40px] items-center text-[15px] text-ink/80 transition-colors duration-150 ease-out hover:text-ink" data-id="element-141" data-mp="1tiisgz032w8i">
                      {link.label}
                    </a>
                  </li>)}
                <li data-id="element-142" data-mp="2c6nthypcw33m">
                  <a href="#top" className="inline-flex min-h-[40px] items-center text-[15px] text-ink/80 transition-colors duration-150 ease-out hover:text-ink" data-id="element-143" data-mp="2c77drm2hb3kt">
                    Back to top
                  </a>
                </li>
              </ul>
            </nav>

            <div data-id="element-144" data-mp="2d0ep1pt3nfuu">
              <h2 className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink/55" data-id="element-145" data-mp="2d42ikoyjo29k">
                Studio
              </h2>
              <ul className="mt-4 space-y-3 text-[15px] text-ink/80" data-id="element-146" data-mp="234lbq47k3ic0">
                <li data-id="element-147" data-mp="1ydbrxk8ov981">blackcometlabs.io</li>
                <li data-id="element-148" data-mp="1ycae580ag8mm">Learning · Lifestyle · Gaming</li>
                <li data-id="element-149" data-mp="1ybilo61zmr0k">Built for U.S. users</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-auto pt-20" data-id="element-150" data-mp="1pcna0eg6copv">
          <p className="pr-16 pt-5 text-xs font-medium text-ink/65" data-id="element-151" data-mp="1pdyfqjt6k6jm">
            © {new Date().getFullYear()} Black Comet Labs. Small studio. Serious apps.
          </p>
        </div>
      </div>
    </footer>;
}